import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef, useContext, useImperativeHandle, useRef, useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { CheckoutAddress } from "@components/organisms";
import { useAuth, useCheckout, useCart } from "@saleor/sdk";
import { ShopContext } from "@temp/components/ShopProvider/context";
import { commonMessages } from "@temp/intl";
import { filterNotEmptyArrayItems } from "@utils/misc";

var CheckoutAddressSubpageWithRef = function CheckoutAddressSubpageWithRef(_ref, ref) {
  var _user$addresses;

  var changeSubmitProgress = _ref.changeSubmitProgress,
      onSubmitSuccess = _ref.onSubmitSuccess,
      props = _objectWithoutProperties(_ref, ["changeSubmitProgress", "onSubmitSuccess"]);

  var checkoutShippingAddressFormId = "shipping-address-form";
  var checkoutShippingAddressFormRef = useRef(null);
  var checkoutBillingAddressFormId = "billing-address-form";
  var checkoutBillingAddressFormRef = useRef(null);
  var checkoutNewAddressFormId = "new-address-form";

  var _useAuth = useAuth(),
      user = _useAuth.user;

  var _useCheckout = useCheckout(),
      checkout = _useCheckout.checkout,
      selectedShippingAddressId = _useCheckout.selectedShippingAddressId,
      selectedBillingAddressId = _useCheckout.selectedBillingAddressId,
      billingAsShipping = _useCheckout.billingAsShipping,
      setShippingAddress = _useCheckout.setShippingAddress,
      setBillingAddress = _useCheckout.setBillingAddress,
      setBillingAsShippingAddress = _useCheckout.setBillingAsShippingAddress;

  var _useCart = useCart(),
      items = _useCart.items;

  var _useContext = useContext(ShopContext),
      countries = _useContext.countries;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      shippingErrors = _useState2[0],
      setShippingErrors = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      billingErrors = _useState4[0],
      setBillingErrors = _useState4[1];

  var intl = useIntl();
  var isShippingRequiredForProducts = items && items.some(function (_ref2) {
    var _variant$product;

    var variant = _ref2.variant;
    return (_variant$product = variant.product) === null || _variant$product === void 0 ? void 0 : _variant$product.productType.isShippingRequired;
  });
  var checkoutShippingAddress = (checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress) ? _objectSpread({}, checkout === null || checkout === void 0 ? void 0 : checkout.shippingAddress, {
    email: (checkout === null || checkout === void 0 ? void 0 : checkout.email) || (user === null || user === void 0 ? void 0 : user.email)
  }) : undefined;
  var checkoutBillingAddress = (checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress) ? _objectSpread({}, checkout === null || checkout === void 0 ? void 0 : checkout.billingAddress, {
    email: (checkout === null || checkout === void 0 ? void 0 : checkout.email) || (user === null || user === void 0 ? void 0 : user.email)
  }) : undefined;
  useImperativeHandle(ref, function () {
    return {
      submitAddress: function submitAddress() {
        if (isShippingRequiredForProducts) {
          var _checkoutShippingAddr;

          (_checkoutShippingAddr = checkoutShippingAddressFormRef.current) === null || _checkoutShippingAddr === void 0 ? void 0 : _checkoutShippingAddr.dispatchEvent(new Event("submit", {
            cancelable: true
          }));
        } else {
          var _checkoutBillingAddre;

          (_checkoutBillingAddre = checkoutBillingAddressFormRef.current) === null || _checkoutBillingAddre === void 0 ? void 0 : _checkoutBillingAddre.dispatchEvent(new Event("submit", {
            cancelable: true
          }));
        }
      }
    };
  });

  var _useState5 = useState(billingAsShipping),
      _useState6 = _slicedToArray(_useState5, 2),
      billingAsShippingState = _useState6[0],
      setBillingAsShippingState = _useState6[1];

  useEffect(function () {
    setBillingAsShippingState(billingAsShipping);
  }, [billingAsShipping]);

  var handleSetShippingAddress =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(address, email, userAddressId) {
      var shippingEmail, _ref4, dataError, errors, _checkoutBillingAddre2;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!address && !billingAsShippingState)) {
                _context.next = 3;
                break;
              }

              setShippingErrors([{
                message: intl.formatMessage(_defineProperty({
                  defaultMessage: "Please provide shipping address.",
                  "id": "@next.pages.SecureCheckoutPage.subpages.CheckoutAddressSubpage.929802659"
                }, "id", "@next.pages.SecureCheckoutPage.subpages.CheckoutAddressSubpage.929802659"))
              }]);
              return _context.abrupt("return");

            case 3:
              shippingEmail = (user === null || user === void 0 ? void 0 : user.email) || email || "";

              if (shippingEmail) {
                _context.next = 7;
                break;
              }

              setShippingErrors([{
                field: "email",
                message: intl.formatMessage(commonMessages.provideEmailAddress)
              }]);
              return _context.abrupt("return");

            case 7:
              changeSubmitProgress(true);
              _context.next = 10;
              return setShippingAddress(_objectSpread({}, address, {
                id: userAddressId
              }), shippingEmail);

            case 10:
              _ref4 = _context.sent;
              dataError = _ref4.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;

              if (errors) {
                setShippingErrors(errors);
                changeSubmitProgress(false);
              } else {
                setShippingErrors([]);

                if (billingAsShippingState) {
                  handleSetBillingAddress();
                } else {
                  (_checkoutBillingAddre2 = checkoutBillingAddressFormRef.current) === null || _checkoutBillingAddre2 === void 0 ? void 0 : _checkoutBillingAddre2.dispatchEvent(new Event("submit", {
                    cancelable: true
                  }));
                }
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSetShippingAddress(_x, _x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSetBillingAddress =
  /*#__PURE__*/
  function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(address, email, userAddressId) {
      var billingEmail, errors, _ref6, dataError, _ref7, _dataError;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!address && !billingAsShippingState)) {
                _context2.next = 3;
                break;
              }

              setBillingErrors([{
                message: intl.formatMessage(_defineProperty({
                  defaultMessage: "Please provide billing address.",
                  "id": "@next.pages.SecureCheckoutPage.subpages.CheckoutAddressSubpage.2558335134"
                }, "id", "@next.pages.SecureCheckoutPage.subpages.CheckoutAddressSubpage.2558335134"))
              }]);
              return _context2.abrupt("return");

            case 3:
              billingEmail = (user === null || user === void 0 ? void 0 : user.email) || email;

              if (!(!billingEmail && !billingAsShippingState && !isShippingRequiredForProducts)) {
                _context2.next = 7;
                break;
              }

              setBillingErrors([{
                field: "email",
                message: intl.formatMessage(commonMessages.provideEmailAddress)
              }]);
              return _context2.abrupt("return");

            case 7:
              changeSubmitProgress(true);

              if (!(billingAsShippingState && isShippingRequiredForProducts)) {
                _context2.next = 16;
                break;
              }

              _context2.next = 11;
              return setBillingAsShippingAddress();

            case 11:
              _ref6 = _context2.sent;
              dataError = _ref6.dataError;
              errors = dataError === null || dataError === void 0 ? void 0 : dataError.error;
              _context2.next = 21;
              break;

            case 16:
              _context2.next = 18;
              return setBillingAddress(_objectSpread({}, address, {
                id: userAddressId
              }), billingEmail);

            case 18:
              _ref7 = _context2.sent;
              _dataError = _ref7.dataError;
              errors = _dataError === null || _dataError === void 0 ? void 0 : _dataError.error;

            case 21:
              changeSubmitProgress(false);

              if (errors) {
                setBillingErrors(errors);
              } else {
                setBillingErrors([]);
                onSubmitSuccess();
              }

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSetBillingAddress(_x4, _x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();

  var userAdresses = user === null || user === void 0 ? void 0 : (_user$addresses = user.addresses) === null || _user$addresses === void 0 ? void 0 : _user$addresses.filter(filterNotEmptyArrayItems).map(function (address) {
    return {
      address: _objectSpread({}, address, {
        isDefaultBillingAddress: address.isDefaultBillingAddress || false,
        isDefaultShippingAddress: address.isDefaultShippingAddress || false,
        phone: address.phone || undefined
      }),
      id: (address === null || address === void 0 ? void 0 : address.id) || "",
      onSelect: function onSelect() {
        return null;
      }
    };
  });
  return React.createElement(CheckoutAddress, _extends({}, props, {
    shippingErrors: shippingErrors,
    billingErrors: billingErrors,
    shippingFormId: checkoutShippingAddressFormId,
    shippingFormRef: checkoutShippingAddressFormRef,
    billingFormId: checkoutBillingAddressFormId,
    billingFormRef: checkoutBillingAddressFormRef,
    checkoutShippingAddress: checkoutShippingAddress,
    checkoutBillingAddress: checkoutBillingAddress,
    billingAsShippingAddress: billingAsShippingState,
    email: checkout === null || checkout === void 0 ? void 0 : checkout.email,
    userAddresses: userAdresses,
    selectedUserShippingAddressId: selectedShippingAddressId,
    selectedUserBillingAddressId: selectedBillingAddressId,
    countries: countries,
    userId: user === null || user === void 0 ? void 0 : user.id,
    newAddressFormId: checkoutNewAddressFormId,
    shippingAddressRequired: !!isShippingRequiredForProducts,
    setShippingAddress: handleSetShippingAddress,
    setBillingAddress: handleSetBillingAddress,
    setBillingAsShippingAddress: setBillingAsShippingState
  }));
};

var CheckoutAddressSubpage = forwardRef(CheckoutAddressSubpageWithRef);
export { CheckoutAddressSubpage };